import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home"),
    meta: {
      title: "",
      withoutPadding: true
    }
  },
  {
    path: "/about/gallery",
    name: "Gallery",
    component: () => import("../views/about/Gallery"),
    meta: {
      title: "Галерея"
    }
  },
  {
    path: "/about/history",
    name: "History",
    component: () => import("../views/about/History"),
    meta: {
      title: "История"
    }
  },
  {
    path: "/about/mass-media",
    name: "SMM",
    component: () => import("../views/about/SMM"),
    meta: {
      title: "Мы в СМИ"
    }
  },
  {
    path: "/about/graduates",
    name: "Graduates",
    component: () => import("../views/about/Graduates"),
    meta: {
      title: "Выпускники"
    }
  },
  {
    path: "/schedule/:id",
    name: "Schedule",
    component: () => import("../views/Schedule"),
    meta: {
      title: "Расписание"
    }
  },
  {
    path: "/faces",
    name: "Faces",
    component: () => import("../views/Faces"),
    meta: {
      title: "Лица школы"
    }
  },
  {
    path: "/lab",
    name: "LSTC",
    component: () => import("../views/Lstc"),
    meta: {
      title: "Лаборатория научно‑технического творчества",
      withoutPadding: true
    }
  },
  {
    path: "/gratitude",
    name: "Gratitude",
    component: () => import("../views/Gratitude"),
    meta: {
      title: "Благодарности"
    }
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("../views/Contacts"),
    meta: {
      title: "Контакты"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/NotFound"),
    meta: {
      title: "404"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
];

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  store.dispatch("getCourses");
  store.dispatch("getTeacherTypes");
  store.dispatch("changePageTitle", to.meta.title);
  store.state.headerPadding = !to.meta.withoutPadding;
  next();
});

export default router;
